/**
 * Created by fers on 22/11/16.
 */

/* global Set */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import LoadingButton from '../../fw/LoadingButton.react';
import {FormattedMessage, injectIntl} from 'react-intl';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import dataSourceHandlers from './../datasource-handlers/handlers';
import {getMessageArgsForDataSource} from './DataSourceList.react';
import DataSourceMatch from '../datasource-handlers/DataSourceMatchAdd.react';
import DataSourceRelation from '../datasource-handlers/DataSourceRelationAdd.react';
import DataSourceQuery from '../datasource-handlers/DataSourceQueryAdd.react';
import DataSourceManualQuery from '../datasource-handlers/DataSourceManualQueryAdd.react';
import DataSourceSearchActionAdd from '../datasource-handlers/DataSourceSearchActionAdd.react';
import DataSourceCompanySearchAdd from '../datasource-handlers/DataSourceCompanySearchAdd.react';
import {getEditDataSourceFragment} from './../box-utils/ScreenDisplayer.react';
import {assert} from 'chai';

class DataSourcesToAdd extends React.Component {
    static propTypes = {
        dataSource: PropTypes.object.isRequired,
        dataSourceList: PropTypes.object.isRequired,
		dataSourcesCnt: PropTypes.number.isRequired,
        idx: PropTypes.number,
        intl: PropTypes.object,
        screen: PropTypes.object.isRequired,
        screenSettings: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedDataSourceToAdd: null,
        };
    }

    setSelectedDataSourceToAdd(dataSourceToAdd) {
        this.setState({
            selectedDataSourceToAdd: dataSourceToAdd
        });
    }

	// eslint-disable-next-line max-params
    renderDataSource(screenSettings, dataSource, dataSourceToAdd, idx2) {
        let messageArgs = getMessageArgsForDataSource(dataSourceToAdd, dataSource);

        let name = dataSourceToAdd.name;
        name = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSourceToAdd.typeId + '.name',
        }, messageArgs);

        let description = dataSourceToAdd.description;
        description = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSourceToAdd.typeId + '.description',
        }, messageArgs);

        return (
            <div className="dataSource-add-table" key={idx2}>
                <div className="dataSource-add-icon">
                    <ChannelIcon channelDef={dataSourceToAdd.channelDef ? dataSourceToAdd.channelDef : dataSourceToAdd} size={32} />
                </div>
                <div className="dataSource-add-title">
                    <strong>{name}</strong><br/>
                    {description ? <p>{description}</p> : null}

                    {dataSourceToAdd.uiAddHandler ?
                        <LoadingButton className="btn btn-default" onClick={() => {
                            return this.setSelectedDataSourceToAdd(dataSourceToAdd);
                        }}>
                            <FormattedMessage defaultMessage="More" id="screenSettings.moreThisQuery" />{" "}<span aria-hidden="true" className="fa fa-chevron-right"></span>
                        </LoadingButton>
                        :
                        <LoadingButton className="btn btn-default" onClick={() => {
                            return screenSettings.onClickAddDataSource(dataSourceToAdd).then(() => this.props.dataSourceList.goBack());
                        }}>
                            <span aria-hidden="true" className="fa fa-plus"></span>{" "}<FormattedMessage defaultMessage="Add" id="screenSettings.addThisQuery" />
                        </LoadingButton>
                    }

                </div>
            </div>
        );
    }

    render() {
        if (this.state.selectedDataSourceToAdd) {
            let uiAddHandler = this.state.selectedDataSourceToAdd.uiAddHandler;
            if (uiAddHandler) {
                let component = dataSourceHandlers[uiAddHandler];
                if  (component) {
                    return React.createElement(component.handler, {
                        dataSourceToAdd: this.state.selectedDataSourceToAdd,
                        dataSource: this.props.dataSource,
                        apply: (dataSource) => {
                            return this.props.screenSettings.onClickAddDataSource(dataSource).then(() => this.props.dataSourceList.goBack());
                        },
                        goBack: () => {
                            this.setSelectedDataSourceToAdd(null);
                        }
                    });
                }
            }
        }

        let dataSource = this.props.dataSource;
        assert.isDefined(dataSource);

        let screen = this.props.screen;
        let screenSettings = this.props.screenSettings;
        let idx = this.props.idx;

        let messageArgs = getMessageArgsForDataSource(dataSource, dataSource.relativeTo);

        let name = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.name',
        }, messageArgs);

        let description = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.description',
        }, messageArgs);

        if (dataSource.entityDefs && dataSource.entityDefs.length > 0) {
            let filteredDataSources = dataSource.dataSourcesToAdd.filter((dataSource2) => {
                let find = screen.dataSources.find((a) => {
                    if (!a['keepUnique']) {
                        return false;
                    }

                    return a['relativeTo_id'] === dataSource['realId'] && (a['typeId'] ? a['typeId'] === dataSource2['typeId'] :  a['type'] === dataSource2['type']);
                });
                return find ? false : true;
            });

			let hasFilteredDataSources = filteredDataSources.length > 0;

			let groups = [...new Set(filteredDataSources.map((ds) => ds.group))];

			let dsWidth = 12 / (groups.length ? groups.length : 1);

            return (
                <div className="dataSource-item-box" key={idx}>
                    <div className="dataSource-item-detail">
                        <div className="dataSource-head flex">
							<div className={"dataSource-item-close"}>
								<div className="btn btn-inline" onClick={this.props.dataSourceList.goBack}><span className="fa fa-chevron-left"/></div>
							</div>
                            <div className="dataSource-idx-box">
                                <span className="dataSource-idx" title={description}>#{dataSource.idx}</span>
                            </div>
                            <div className="dataSource-title-icon">
                                {dataSource.channelDefs && dataSource.channelDefs.length > 0 ? dataSource.channelDefs.map((channelDef, idx) => channelDef.icon ? <ChannelIcon channelDef={channelDef} key={idx} size={32} /> : null) : <ChannelIcon channelDef={{icon: 'dativery'}} size={32} />}
                            </div>
                            <div className={"dataSource-item-title" + (description ? '' : ' one-line-title')}>
                                <h3>{name}</h3>

                                {description ? <small>{description}</small> : null}
                            </div>
                        </div>

                        <div className={"dataSource-item-dataSources" + (hasFilteredDataSources ? '' : ' empty')}>
                            {hasFilteredDataSources > 0 ?
                                <div className="dataSource-add-relative">
                                    <div className="container">
                                        {groups.map((group, idx) => {
                                            return (
                                                <div className={"col-sm-" + dsWidth} key={idx}>
                                                    {filteredDataSources.filter((ds) => ds.group === group).map((dataSourceToAdd, idx2) => {
                                                        return this.renderDataSource(screenSettings, dataSource, dataSourceToAdd, idx2);
                                                    })}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                : <span className="empty"><FormattedMessage defaultMessage="No extension is available for this data query." id="screenSettings.noDataSourceToAdd" /></span>}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Relay.createContainer(injectIntl(DataSourcesToAdd), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    relativeTo {
                        entityDefs {
                            id,
                            name,
                        },
                        channelDefs {
                            id,
                            name,
                        }
                    }
                    dataSourcesToAdd {
                        id,
                        realId,
                        keepUnique,
                        type,
                        typeId,
                        group,
                        uiAddHandler,
                        name,
                        description,
                        icon,
                        entityDef_id,
                        relativeTo_id,
                        channelDef_id,
                        channelDef {
                            id,
                            name,
                            icon
                        },
                        channel_id,
                        channel {
                            id,
                            name,
                        }
                        helperEntityDef_id,
                        helperChannelDef_id,
                        helperChannel_id,
                        helperChannel {
                            id,
                            name,
                        }
                    },
                    ${getEditDataSourceFragment()},
                    ${DataSourceRelation.getFragment('dataSource')},
                    ${DataSourceMatch.getFragment('dataSource')},
                    ${DataSourceCompanySearchAdd.getFragment('dataSource')},
                    ${DataSourceQuery.getFragment('dataSource')},
                    ${DataSourceManualQuery.getFragment('dataSource')},
                    ${DataSourceSearchActionAdd.getFragment('dataSource')}
                }`;
        }
    }
});
